import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import { ToggleProvider } from './contexts/ToggleContext';


function App() {
    const handleIconClick = (processType) => {
        console.log(`Processing video with ${processType}`);
    };

    console.log("App.js: Working")

    return (
        <div className="App lava-theme">
            <ToggleProvider>
                <Routes>
                    <Route
                        path="/login"
                        element={
                            <PublicRoute>
                                <Login />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <LandingPage onIconClick={handleIconClick} />
                            </PrivateRoute>
                        }
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </ToggleProvider>
        </div>
    );
}

const PublicRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('username') !== null;
    return isAuthenticated ? <Navigate to="/" replace /> : children;
};

const PrivateRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('username') !== null;
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default App;
